import { atom } from "recoil";
import { Dirary } from "../types/dirary";

export const diaryListState = atom<Dirary[]>({
  key: "diaryListState",
  default: [],
});

export const diaryListStateForMatrix = atom<Dirary[]>({
  key: "diaryListStateForMatrix",
  default: [],
});
